module.exports = __webpack_public_path__ + "img/inbulk.c8e703af.jpg";